import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faRobot } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";

// DO NOT copy this pattern. The [&_button] wrapper hack exists solely for CopilotButton's
// gradient border and must not spread across the codebase. If you need a custom-styled button,
// create a proper variant in the Button component instead.
export const CopilotButton: React.FC<{
  onClick: () => void;
  disabled: boolean;
  icon?: IconDefinition;
  dataLoc?: string;
  children: React.ReactNode;
}> = ({
  disabled,
  onClick,
  icon = faRobot,
  dataLoc = "copilot-button",
  children,
}) => {
  return (
    <div className="[&_button]:border-transparent [&_button]:[background:linear-gradient(white,white)_padding-box,radial-gradient(110%_150%_at_0%_16%,#A1FF09_0%,#493FC1_100%)_border-box]">
      <Button
        dataLoc={dataLoc}
        disabled={disabled}
        iconLeft={icon}
        size="sm"
        variant="secondary"
        onClick={onClick}
      >
        <span className="whitespace-nowrap">{children}</span>
      </Button>
    </div>
  );
};
